import { getRouteApi, useNavigate } from '@tanstack/react-router';
import * as React from 'react';

import type { CampaignStatusBucket } from '@/lib/campaign-labels';
import { CampaignsListScreen } from '@/routes/admin/campaigns/campaigns-list-screen';

// =============================================================================
// campaigns-list-route.tsx — Adaptateur routeur de l'écran « Campagnes » (liste).
// =============================================================================
// Lie la navigation (TanStack Router) au composant de présentation (testable hors
// routeur). Ouvre le détail (« /admin/campaigns/$campaignId »). Le filtre de statut
// opérationnel (A-12) vit dans le SEARCH PARAM d'URL `statut` (RULE_REF_006 : pas de
// localStorage pour l'état de vue) ; le composant de présentation reste testable hors routeur.
//
// A-12 refonte (GATE_HUMAN 2026-09-16, point 2) : la colonne « Référence catalogue » est
// supprimée du registre ; la résolution des versions de catalogue (CatalogAdminClientProvider +
// useCatalogVersions) n'a plus lieu d'être ici. Les clients API de la section inférieure
// (suivi fournisseurs, relances, référentiel clients) viennent de leurs contextes (défaut = HTTP réel).

const routeApi = getRouteApi('/admin/campaigns');

export function CampaignsListRoute(): React.JSX.Element {
  const navigate = useNavigate();
  const { statut } = routeApi.useSearch();

  const onOpen = React.useCallback(
    (campaignId: string): void => {
      void navigate({
        to: '/admin/campaigns/$campaignId',
        params: { campaignId },
      });
    },
    [navigate],
  );

  const onChangeStatusFilter = React.useCallback(
    (bucket: CampaignStatusBucket): void => {
      void navigate({
        to: '/admin/campaigns',
        // « tous » = défaut implicite : on retire le search param de l'URL.
        search: bucket === 'tous' ? {} : { statut: bucket },
      });
    },
    [navigate],
  );

  return (
    <CampaignsListScreen
      onOpen={onOpen}
      statusFilter={statut ?? 'tous'}
      onChangeStatusFilter={onChangeStatusFilter}
    />
  );
}
